module.exports = __webpack_public_path__ + "img/in-use-joel@1x.38ed82f2.jpg";